import type { Schema } from '@/api/client'
import { trimSeconds } from './times'

/** One line for a read-only row: `09:30–18:30 IST · weekdays only`. */
export function summariseSendWindow(automation: Schema<'AutomationOut'>): string {
  const hours = `${trimSeconds(automation.window_start)}–${trimSeconds(automation.window_end)} IST`
  return automation.skip_weekends ? `${hours} · weekdays only` : `${hours} · every day`
}
